(function ($, njm) {
    'use strict';

    njm.views.agentBlogSearch = Backbone.View.extend({
		
        events: {
            'click .blogsearch a': 'submitSearch'
        },  
        /**
         * Initialize
         */
        initialize: function () {
			var $this = this;
			$('.comp-header-agent-blog .mobile-toggle .icon-arrow, .comp-header-agent-blog .mobile-toggle .icon-search-desktop').on({
				click: function(event) {
					$this.toggleSearch(event);
				},
				keydown: function(event) {
					$this.handleKeypress(event);
				}
			});
			
			this.mobileState = 'expanded';
			
			this.collapse();
		},
		
		toggleSearch: function(event) {
			var target = $(event.target);
			var search = target.parents('.search');
			
			if (search.hasClass('collapsed')) {
				this.expand();
			} else if (search.hasClass('expanded')) {
				this.collapse();
			}
		},
		
		handleKeypress: function (event) {
			var key = event.which;
					
			if (key === 13 || key === 32) { //space or enter key
				event.preventDefault();
				this.toggleSearch(event);
			}
			
			if (key === 27) { //escape key
				this.collapse();
			}
		},
		
		collapse: function() {
			var search = $('.comp-header-agent-blog .search');
			if (this.mobileState === 'expanded') {
				search.removeClass('expanded').addClass('collapsed');
				search.find('input').attr('tabindex','-1');
				search.find('a').attr('tabindex','-1');
				this.mobileState = 'collapsed';
			}
		},
		
		expand: function() {
			var search = $('.comp-header-agent-blog .search');
			if (this.mobileState === 'collapsed') {
				search.removeClass('collapsed').addClass('expanded');
				search.find('input').attr('tabindex','0').focus();
				search.find('a').attr('tabindex','0');
				this.mobileState = 'expanded';
			}
        },
        /**
         * Submit search
         */
        submitSearch: function (e) {
            if (e.type === 'click') {
                e.preventDefault();
                var form = this.$('.blogsearch form')[0];
                form.submit();
            }
        }
    });
})(jQuery, njm);
